import BusinessScene from '../../scenes/MarketingPages/scenes/Enterprise';

export default BusinessScene;
